/*
 * @Author: luting
 * @Date: 2022-04-19 18:54:08
 * @lastEditors: luting
 * @LastEditTime: 2023-07-11 13:17:55
 */
import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Button, Input, Form, Checkbox, Row, Col, Select, Spin } from 'sup-ui';
import { getAvailabledDisksApi, getPartitionStatusApi, postPartitionApi, getVginfo } from 'root/services/disk';

import { useDispatch } from 'react-redux';
import { common } from 'root/store/actions';

import messages from '../messages';
import CommonModal from 'root/components/CommonModal';
import { WrappedFormUtils } from 'sup-ui/lib/form/Form';
import successImg from 'root/assets/images/illustrator_partitionsucceeded.png';
import failedImg from 'root/assets/images/illustrator_partitionfailed.png';

import creatingImg from 'root/assets/images/illustrator_inpartition.png';
import styles from '../index.less';
interface PropsType {
  setRefresh: any;
  refresh: boolean;
  form: WrappedFormUtils;
}
const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};

const { Option } = Select;

let loopTimer: any = null;

const InitNoDataPage = (props: PropsType) => {
  const intl = useIntl();
  const dispath = useDispatch();

  const { setRefresh, form } = props;
  const [diskList, setDiskList] = useState<any[]>([]);

  const { getFieldDecorator } = form;
  const [visible, setVisible] = useState(false);
  const [selectDisk, setSelectDisk] = useState(0);
  const [status, setStatus] = useState('init'); // init:初始化   creating:创建中  success:创建成功  failed:创建失败
  const [errorText, setErrorText] = useState('');
  const [capacityError, setCapacityError] = useState(false);
  const [vgList, setVgList] = useState<any[]>([]);

  useEffect(() => {
    if (!visible && status === 'success') {
      setRefresh(true);
      dispath(common.updateSuposDir({ hasSuposCatalogue: true }));
      sessionStorage.setItem('hasSuposCatalogue', 'true');
    }
    if (!visible) return;
    getDiskList();
    checkStatus();
    getVginfoEvent();
    // getPartionInfo();
  }, [visible]);

  // 获取卷组信息
  const getVginfoEvent = () => {
    getVginfo({ clientIds: [] }).then((res) => {
      const { data = [] } = res;
      data.unshift({ label: intl.formatMessage(messages.newVg), name: 'new' });
      setVgList(data);
    });
  };

  // 选择磁盘后校验容量是否超过总量
  useEffect(() => {
    const capacity = form.getFieldValue('capacity');
    if (capacity) {
      form.validateFields();
    }
  }, [selectDisk]);

  // 获取可用磁盘列表
  const getDiskList = () => {
    getAvailabledDisksApi({ clientIds: [] }).then((res) => {
      const { data } = res;
      setDiskList(data);
    });
  };

  const onCancel = () => {
    setVisible(false);
  };

  // 选择卷组,更新可用容量
  const vgChange = (val: string) => {
    const size = vgList.find((item) => item.name === val)?.leftSize;
    setSelectDisk(size || 0);
    form.setFieldsValue({ disk: '' });
  };
  // 选择磁盘
  const changeDisk = (value: any) => {
    let count = 0;
    const vgName = form.getFieldValue('volumeGroup');
    if (vgName !== 'new') {
      const size = vgList.find((item) => item.name === vgName)?.leftSize;
      count += Number(size);
    }
    value.forEach((item: any) => {
      count += Number(item.size);
    });
    setSelectDisk(count);
  };

  // 提交表单信息
  const post = () => {
    if (status === 'failed') {
      setStatus('init');
      return;
    }

    form.validateFields((err, values) => {
      if (!err) {
        const { capacity, disk, mountPoint, volumeGroup } = values;

        const params = {
          diskList: disk ? disk?.map((item: any) => item.path) : [],
          mountPoints: [{ name: mountPoint, size: capacity }],
          vgName: volumeGroup !== 'new' ? volumeGroup : '',
        };

        postPartitionApi(params).then(() => {
          getPartionInfo();
        });
      }
    });
  };
  // 限制容量不能输入小数点
  const capacityInput = (ele: any) => {
    let { value } = ele.target;
    value = value.replace(/^(0+)|[^\d]+/g, '');
    ele.target.value = value;
  };
  // 校验容量
  const validatorCapacity = (rule: any, value: string, callbackFn: Function) => {
    setCapacityError(false);
    if (!value) {
      return callbackFn();
    }
    if (isNaN(Number(value))) {
      return callbackFn(intl.formatMessage(messages.capacityError));
    }
    if (Number(value) > selectDisk) {
      setCapacityError(true);
      return callbackFn(intl.formatMessage(messages.maxError));
    }
    callbackFn();
  };

  // 轮询获取分区状态
  const loopGetData = () => {
    loopTimer = setTimeout(() => {
      clearTimeout(loopTimer);
      getPartionInfo();
    }, 3000);
  };

  const checkStatus = () => {
    // 如果正在分区中
    getPartitionStatusApi({ clientIds: [] }).then((res) => {
      const { data } = res;
      if (data?.status === 'RUNNING') {
        setStatus('creating');
        loopGetData();
      }
    });
  };

  // 获取分区信息
  const getPartionInfo = () => {
    getPartitionStatusApi({ clientIds: [] }).then((res) => {
      // 分区完成
      if (res.data.status === 'FINISHED') {
        clearTimeout(loopTimer);
        loopTimer = null;

        if (res.data.result === 'SUCCESS') {
          setStatus('success');
        } else {
          setStatus('failed');
        }
        setErrorText(res.data.err);
        return;
      }

      // 正在分区中
      setStatus('creating');
      loopGetData();
    });
  };

  const renderStatusContext = () => {
    switch (status) {
      case 'init':
        return (
          <Form {...formItemLayout}>
            <Form.Item label={intl.formatMessage(messages.volumeGroup)} colon={false}>
              {getFieldDecorator('volumeGroup', {
                initialValue: 'new',
                rules: [
                  {
                    required: true,
                  },
                ],
              })(
                <Select className={styles.queryInput} onChange={vgChange}>
                  {vgList.map((item) => {
                    return (
                      <Option key={item.name} value={item.name}>
                        {item.label || item.name}
                      </Option>
                    );
                  })}
                </Select>,
              )}
            </Form.Item>

            <Form.Item label={intl.formatMessage(messages.mountPoint)} colon={false}>
              {getFieldDecorator('mountPoint', {
                initialValue: '/home/supos/supos',
                rules: [
                  {
                    required: true,
                  },
                ],
              })(<Input className={styles.queryInput} maxLength={64} disabled={true} />)}
            </Form.Item>
            {form.getFieldValue('volumeGroup') === 'new' ? (
              <Form.Item label={intl.formatMessage(messages.disk)} colon={false}>
                {getFieldDecorator('disk', {
                  initialValue: '',
                  rules: [
                    {
                      required: true,
                      message: intl.formatMessage(messages.diskNull),
                    },
                  ],
                })(
                  diskList.length ? (
                    <Checkbox.Group className={styles.checkboxGroup} onChange={changeDisk}>
                      {diskList.map((item) => {
                        const { name, size } = item;
                        return (
                          <Row key={name}>
                            <Col>
                              <Checkbox value={item}>
                                {name} {size}
                              </Checkbox>
                            </Col>
                          </Row>
                        );
                      })}
                    </Checkbox.Group>
                  ) : (
                    <span className={styles.volumeUnavailable}>{intl.formatMessage(messages.volumeUnavailable)}</span>
                  ),
                )}
              </Form.Item>
            ) : null}

            <span className={styles.refresh} onClick={getDiskList}>
              {intl.formatMessage(messages.refresh)}
            </span>
            <Form.Item label={intl.formatMessage(messages.capacity)} colon={false}>
              {getFieldDecorator('capacity', {
                initialValue: '',
                rules: [
                  {
                    required: true,
                    message: intl.formatMessage(diskList.length ? messages.capacityNull : messages.capacityTip),
                  },
                  { validator: validatorCapacity },
                ],
              })(<Input className={styles.queryInput} maxLength={64} onInput={capacityInput} />)}
              <span className={styles.selectDisk} style={capacityError ? { color: 'red' } : {}}>
                ≤{selectDisk}G
              </span>
            </Form.Item>
            {form.getFieldValue('volumeGroup') !== 'new' ? (
              <Form.Item label={intl.formatMessage(messages.expansion)} colon={false}>
                {getFieldDecorator('disk', {
                  initialValue: '',
                })(
                  diskList.length ? (
                    <Checkbox.Group className={styles.checkboxGroup} onChange={changeDisk}>
                      {diskList.map((item) => {
                        const { name, size } = item;
                        return (
                          <Row key={name}>
                            <Col>
                              <Checkbox value={item}>
                                {name} {size}
                              </Checkbox>
                            </Col>
                          </Row>
                        );
                      })}
                    </Checkbox.Group>
                  ) : (
                    <span className={styles.volumeUnavailable}>{intl.formatMessage(messages.volumeUnavailable)}</span>
                  ),
                )}
              </Form.Item>
            ) : null}
          </Form>
        );
      case 'creating':
        return (
          <div className={styles.creating}>
            <div>
              <img src={creatingImg} className={styles.statusImg} />
              <Spin size="small" />
              <span className={styles.createText}>{intl.formatMessage(messages.creating)}</span>
            </div>
          </div>
        );
      case 'success':
        return (
          <div className={styles.success}>
            <div>
              <img src={successImg} className={styles.statusImg} />
              {intl.formatMessage(messages.createSuccess)}
            </div>
          </div>
        );
      case 'failed':
        return (
          <div className={styles.failed}>
            <div>
              <img src={failedImg} className={styles.statusImg} />
              <div>{intl.formatMessage(messages.createFailed)}</div>
              <div className={styles.failedText}>{errorText}</div>
            </div>
          </div>
        );
    }
  };

  return (
    <div className={styles.init_data_page}>
      <div className={styles.tip}>{intl.formatMessage(messages.initPageTip)}</div>
      <div style={{ marginTop: 20 }}>
        <Button
          type="primary"
          onClick={() => {
            setVisible(!visible);
          }}
        >
          {intl.formatMessage(messages.addHomeDisk)}
        </Button>
        {/* <Button onClick={() => setRefresh(!refresh)} style={{ marginLeft: 10 }}>
          {intl.formatMessage(messages.getStatusAgain)}
        </Button> */}
      </div>

      <CommonModal
        visible={visible}
        onCancel={onCancel}
        title={intl.formatMessage(messages.createDiskTitle)}
        footer={
          ['creating', 'success'].includes(status)
            ? [
                <Button type="primary" key="add" onClick={onCancel} disabled={status === 'creating'}>
                  {intl.formatMessage(messages.sure)}
                </Button>,
              ]
            : [
                <Button type="primary" key="add" onClick={post}>
                  {intl.formatMessage(status === 'failed' ? messages.retry : messages.sure)}
                </Button>,
                <Button onClick={onCancel} key="cancel">
                  {intl.formatMessage(messages.cancel)}
                </Button>,
              ]
        }
        height="auto"
      >
        <div className={styles.modalContent}>{renderStatusContext()}</div>
      </CommonModal>
    </div>
  );
};

export default Form.create()(InitNoDataPage);
